"use client";

export function Footer() {
	// compute current year on client
	const year = new Date().getFullYear();

	return (
		<footer className="relative bottom-0 w-full py-6 text-center">
			<p className="text-sm text-gray-500">
				© {year} ARC Document Solutions, LLC. All rights reserved. ISO/IEC 27001:2022 Certified & SOC2 Compliant.
			</p>
		</footer>
	);
}
